import React, { Component } from 'react'
import Header from '../Header'
import './IVaw.css'

class IVaw extends Component {
  
    render () {
        return (
            <div>
                <Header />
                <div className="bodyIVaw">
                    <p className="textIVaw">A venir...</p>
                </div>
            </div>
        )
    }
}

export default IVaw